import { Alert, Button, Col, Collapse, Icon, List, message, Modal, Pagination, Radio, Row, Spin, Steps, Tag, Tooltip } from 'antd';
import Dropdown from 'antd/lib/dropdown';
import Menu from 'antd/lib/menu';
import classNames from 'classnames';
import JavascriptTimeAgo from 'javascript-time-ago';
import en from 'javascript-time-ago/locale/en';
import moment from 'moment';
import * as React from 'react';
import injectSheet from 'react-jss';
import { connect } from 'react-redux';
import { withRouter } from 'react-router';
import { bindActionCreators } from 'redux';
import {
  resetShipmentData,
  startPoller,
  stopPolling,
} from 'src/actions/shipmentTrackingActions';
import { disableContainerByContainerNumber, editBL, editContainer } from 'src/api/shipmentTracking';
import { colorStatusMapping } from 'src/colorScheme/containerStatus';
import LocationPinIcon from 'src/components/common/icons/LocationPinIcon';
import NotFound404 from 'src/components/common/NotFound404';
import { GOOGLE_PLACES_API_URL, MIN_WIDTH } from 'src/globals';
import { commonStyles } from 'src/Library/CommonStyles';
import { clone, isValidArray, isValidBoolean } from 'src/Library/Helper';
import { StylesProps, UserData } from 'src/Library/Types';
import { getContainerTrackingRoute } from 'src/routing/utils';
import { containerTrackingPermissions } from 'src/selectors/importsFilter';
import intercom from 'src/sessionScript/intercomscript.js';
import LightHouseIcon from '../../common/icons/LightHouseIcon';
import ShipOutlinedIcon from '../../common/icons/ShipOutlinedIcon';
import ProductSideDrawer from '../masters/Product/ProductSideDrawer';
import AddManualTrackingEventModal from './AddManualTrackingEventModal';
import BLContainerDetailModal from './BLContainerDetailModal';
import ContainerDetailsTrackingList from './ContainerDetailsTrackingList';
import {
  EVENT_TYPE,
  MOVEMENT_TYPES,
  SHIPMENT_TYPE,
  STATUS_KEYS,
  STATUS_LABELS,
  viewToggle
} from './ContainerUtils';
import { CardData, Container } from './Interfaces/Shipment.interface';
import { CTPermissions } from './Interfaces/TypesInShipmentTracking';
import QuickAddContainerTracking from './QuickAddContainerTracking';
import { getShipmentNumber } from './ShipmentTrackingHelper';
import SubContainerCard from './SubContainerCard';
import UnifiedTrackingTimeline from './UnifiedShipmentView/TrackingTImeline';
import { tokens } from 'src/design-system';
import MapVesselRoute from './VesselTracking/MapVesselRoute';
declare global {
  interface Window {
    Intercom?: any;
  }
}
const {
  useEffect,
  useState,
  memo,
} = React;

const styles = (theme: any) => ({
  ...commonStyles(theme),
  success: {
    backgroundColor: tokens.colors.success,
    borderColor: tokens.colors.success,
    color: tokens.colors.bgWhite,
    textTransform: 'capitalize',
    marginLeft: tokens.spacing.md,
    fontSize: tokens.fontSize.caption,
    fontWeight: tokens.fontWeight.regular,
    borderRadius: '18px',
  },
  cursorStyle: {
    cursor: 'default !important',
  },
  error: {
    backgroundColor: `${theme.errorColor}`,
    borderColor: `${theme.errorColor}`,
    color: tokens.colors.bgWhite,
    textTransform: 'capitalize',
    marginLeft: tokens.spacing.md,
    fontSize: tokens.fontSize.caption,
    fontWeight: tokens.fontWeight.regular,
    borderRadius: '18px',
  },
  containerTitle: {
    fontSize: tokens.fontSize.h3,
    fontWeight: tokens.fontWeight.semibold,
    color: tokens.colors.textSecondary,
    fontFamily: 'Open Sans',
  },
  containerLabel: {
    fontSize: tokens.fontSize.small,
    color: tokens.colors.textSecondary,
    fontFamily: 'Open Sans',
    margin: `0 ${tokens.spacing.sm}px`,
  },
  placeholder: {
    textAlign: 'center',
    margin: tokens.spacing.md,
  },
  titleCol : {
    fontSize: tokens.fontSize.h3,
    lineHeight: '22px',
    fontWeight: tokens.fontWeight.semibold,
  },
  titleRow : {
    fontSize: tokens.fontSize.body,
    lineHeight: '16px',
    fontWeight: tokens.fontWeight.semibold,
    color: tokens.colors.textSecondary,
    marginTop: tokens.spacing.sm,
    marginBottom: '10px',
    borderTopStyle: 'solid',
    borderTopWidth: '1px',
    borderTopColor: tokens.colors.border,
    paddingTop: tokens.spacing.md,
    paddingLeft: '10px',
  },
  detailsRow: {
    display: 'flex',
    fontSize: tokens.fontSize.small,
    paddingLeft: '10px',
    paddingRight: '10px',
    marginTop: tokens.spacing.ms,
  },
  detailsCol: {
    marginLeft: '10px',
    marginRight: '40px',
  },
  trackingBox: {
    width: '93%',
    margin: '10px 0px',
  },
  row: {
    margin: '10px 0px',
    border: `1px solid ${tokens.colors.border}`,
    backgroundColor: tokens.colors.bgWhite,
    width: '97%',
    padding: tokens.spacing.ms,
    borderRadius: 5,
  },
  rowStyle: {
    padding: tokens.spacing.sm + 2,
  },
  summaryIcon: {
    width: '7em',
  },
  summaryContent: {
    paddingLeft: '25px',
    minWidth: 'calc(100% - 7em)',
  },
  summaryRow: {
    width: '100%',
    display: 'flex',
    flexWrap: 'wrap',
    paddingBottom: '15px',
    alignItems: 'flex-start',
  },
  containerRow: {
    paddingBottom: tokens.spacing.ms,
    width: '100%',
    flexWrap: 'wrap',
    alignItems: 'center',
    display: 'flex',
  },
  imgDiv : {
    borderRight: `1px solid ${tokens.colors.border}`,
    margin: '3% 0 10% 0',
    display: 'flex',
    height: '50px',
    alignItems: 'center',
  },
  img : {
    width: '65%',
  },
  containerNumber: {
    marginTop: 10,
    paddingTop: tokens.spacing.sm,
    marginLeft: '30%',
    fontWeight: 'bold',
    flexDirection: 'row',
    display: 'flex',
    alignItems: 'center',
  },
  addBooking: {
    color: tokens.colors.primary,
    fontSize: 11,
    fontWeight: tokens.fontWeight.semibold,
    cursor: 'pointer',
  },
  summaryCol: {
    width: '25%',
    display: 'flex',
    flexWrap: 'wrap',
    alignItems: 'flex-start',
    paddingRight: '15px',
  },
  wrappedText: {
    whiteSpace: 'nowrap',
    overflow: 'hidden',
    textOverflow: 'ellipsis',
    maxWidth: '60%',
  },
  containerCol: {
    fontWeight: tokens.fontWeight.semibold,
    color: tokens.colors.textSecondary,
    textAlign: 'center',
  },
  label: {
    fontWeight: tokens.fontWeight.semibold,
    fontSize: tokens.fontSize.body,
    color: tokens.colors.textSecondary,
    paddingRight: '15px',
  },
  values: {
    color: tokens.colors.textSecondary,
    textAlign: 'left',
  },
  stepMeta: {
    width: '20%',
    minWidth: 300,
    background: '#218EE9',
    color: tokens.colors.bgWhite,
    borderRadius: tokens.radius.md,
    padding: tokens.spacing.md,
    boxShadow: '0 1px 4px 0 rgba(0, 0, 0, 0.2)',
  },
  portSteps: {
    width: 'calc(80% - 24px)',
    borderRadius: tokens.radius.md,
    display: 'flex',
    alignItems: 'center',
    background: tokens.colors.bgWhite,
    marginLeft: tokens.spacing.lg,
    boxShadow: '0 1px 4px 0 rgba(0, 0, 0, 0.2)',
  },
  subLabels: {
    fontWeight: tokens.fontWeight.regular,
    fontSize: tokens.fontSize.small,
  },
  lastUpdated: {
    fontSize: tokens.fontSize.caption,
    paddingTop: 13,
  },
  containerBreakdown: {
    flexGrow: 1,
  },
  containerStep: {
    width: 466,
  },
  stepCard: {
    width: '90%',
    marginLeft: '15px',
    background: tokens.colors.bgWhite,
    borderRadius: tokens.radius.md,
    boxShadow: '0 1px 4px 0 rgba(0, 0, 0, 0.2)',
  },
  valStyle: {
    fontSize: tokens.fontSize.small,
    // lineHeight: '14px',
    fontWeight: tokens.fontWeight.semibold,
  },
  alignStyle: {
    display: 'flex',
    justifyContent: 'flex-start',
    alignItems: 'flex-start',
  },
  labelStyle: {
    fontSize: 12,
    lineHeight: '14px',
  },
  footer: {
    float: 'right',
  },
  filterButton: {
    color: tokens.colors.textSecondary,
    border: 'none',
    background: 'transparent !important',
    boxShadow: 'none',
    fontWeight: 600,
    borderRadius: 0,
    '&:hover': {
      border: 'none',
      background: 'transparent !important',
      boxShadow: 'none',
    },
  },
  navbarParent: {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'space-between',
    margin: '16px 0px 16px 16px',
  },
  notFound: {
    display: 'flex',
    alignItems: 'center',
    flexDirection: 'column',
    width: '90%',
  },
  blackIcon: {
    fontSize: 70,
    color: tokens.colors.textTertiary,
  },
  notFoundItems: {
    color: tokens.colors.textSecondary,
    textAlign: 'center',
  },
  note: {
    color: tokens.colors.textTertiary,
    fontSize: 11,
    textAlign: 'right',
    alignSelf: 'flex-end',
    fontStyle: 'italic',
  },
  transparentButton: {
    background: 'transparent',
    border: 'none',
    color: tokens.colors.primary,
    boxShadow: 'none',
    '&:hover': {
      border: 'none',
      background: 'transparent',
      boxShadow: 'none',
    },
    '&:focus': {
      backgroundColor: 'transparent',
    },
  },
  anchor: {
    fontSize: tokens.fontSize.body,
    fontWeight: tokens.fontWeight.semibold,
    color: tokens.colors.primary,
    textDecoration: 'none',
    cursor: 'pointer',
    '&:hover': {
      color: tokens.colors.primary,
      textDecoration: 'none',
      cursor: 'pointer',
    },
    '&:active': {
      color: tokens.colors.primary,
      textDecoration: 'none',
      cursor: 'pointer',
    },
    '&:visited': {
      color: tokens.colors.primary,
      textDecoration: 'none',
      cursor: 'pointer',
    },
  },
  detailsHead: {
    fontSize: tokens.fontSize.body,
    fontWeight: tokens.fontWeight.semibold,
    color: tokens.colors.primary,
  },
  anchorForEdit: {
    color: tokens.colors.primary,
    fontSize: tokens.fontSize.small,
    fontWeight: tokens.fontWeight.semibold,
    cursor: 'pointer',
  },
  reportAnchor: {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'flex-start',
    backgroundColor: tokens.colors.bgSubtle,
    padding: '6px 20px',
    color: tokens.colors.primary,
    marginTop: tokens.spacing.lg,
  },
  addTrackingStyle: {
    display: 'flex',
    flexDirection: 'row',
    justifyContent: 'flex-end',
    alignItems: 'center',
    padding: '11px 16px 0 16px',
  },
  addContainerStyle: {
    display: 'flex',
    flexDirection: 'row',
    justifyContent: 'space-around',
    flex: 1,
    marginLeft: 50,
    alignItems: 'center',
    padding: '7px 0 10px 16px',
  },
  devider: {
    color: tokens.colors.textSecondary,
    paddingTop: 10,
    marginTop: 16,
    display: 'flex',
    flexDirection: 'row',
    alignItems: 'center',
  },
  viewToggleStyle: {
    display: 'flex',
    width: '80px',
    flexDirection: 'row',
    justifyContent: 'space-between',
    alignItems: 'center',
  },
  eventTypeToggleStyle: {
    display: 'flex',
    width: 'fit-content',
    flexDirection: 'row',
    justifyContent: 'space-between',
    alignItems: 'center',
    padding: '0px 15px',
  },
  toggleDiv: {
    display: 'flex',
    alignItems: 'center',
    flexDirection: 'row',
    flex: 1,
    paddingRight: '2%',
    justifyContent: 'flex-end',
  },
  tooltipDiv: {
    width: 258,
    backgroundColor: tokens.colors.bgWhite,
    zIndex: tokens.zIndex.sticky,
  },
  statusAndUpdatedAt: {
    display: 'flex',
    justifyContent: 'space-between',
    alignItems: 'center',
    padding: '6px 6px 6px 6px',
  },
  updatedAt: {
    fontSize: 8,
    color: tokens.colors.textTertiary,
  },
  statusPill: {
    height: 12,
    fontSize: 8,
    padding: '2px 8px',
    borderRadius: 6,
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
    color: tokens.colors.bgWhite,
  },
  startExecution: {
    color: tokens.colors.primary,
    textDecoration: 'underline',
    fontSize: tokens.fontSize.caption,
    cursor: 'pointer',
  },
  archiveIcon: {
    fontSize: '17px',
    color: tokens.colors.textTertiary,
    cursor: 'pointer',
    marginRight: '7px',
  },
  showMore: {
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
    color: tokens.colors.primary,
    fontSize: tokens.fontSize.caption,
    cursor: 'pointer',
    marginBottom: '10px',
  },
  portAndCountryDiv: {
    display: 'flex',
    flexDirection: 'column',
    justifyContent: 'flex-start',
    alignItems: 'flex-start',
  },
  port: {
    fontSize: tokens.fontSize.body,
    color: tokens.colors.textSecondary,
    fontWeight: 550,
  },
  country: {
    fontSize: 8,
    color: tokens.colors.textTertiary,
    fontWeight: 550,
  },
  tooltipTrackingDiv: {
    display: 'flex',
    flexDirection: 'row',
    alignItems: 'center',
    padding: '6px 0px',
    borderBottom: '1px solid rgb(217, 217, 217, 0.52)'
  },
  portAndCountry: {
    width: 64,
    display: 'flex',
    flexDirection: 'row',
    justifyContent: 'center'
  },
  steps: {
    '& .ant-steps-item-container .ant-steps-item-title': {
      width: '100%',
    },
    '& .ant-steps-item-container .ant-steps-item-content': {
      minHeight: '36px',
    },
    '& .ant-steps-item:not(:first-child) .ant-steps-item-container .ant-steps-item-tail': {
        borderStyle: 'dotted',
        borderWidth: '1px',
        borderColor: '#00D518',
        marginTop: '12px',
        left: '4.5px',
    },
    '& .ant-steps-item .ant-steps-item-container .ant-steps-item-tail::after': {
      display: 'none'
    },
  },
  progressDot: {
    width: '9px',
    height: '9px',
    borderRadius: '10px',
    marginTop: '8px',
    backgroundColor: '#00D518',
    borderStyle: 'solid',
    borderWidth: '1px',
    borderColor: '#00D518'
  },
  etaMenu:{
    fontSize: '9px !important',
    padding:'0px 10px !important',
    margin:'0px !important',
    lineHeight:'20px !important',
    height:'20px !important',
    color: `${tokens.colors.textTertiary} !important`,
  }
});

const duration = 300;

const transitionStyles = {
  entering: { transition: `opacity ${duration}ms ease-in-out`, opacity: 0 },
  entered: { transition: `opacity ${duration}ms ease-in-out`, opacity: 1 },
  exiting: { opacity: 0 },
  exited: { opacity: 0 },
};

const map = {
  containerTrackingBL: 'bl',
  containerTrackingContainer: 'container',
  containerTrackingShipment: 'shipment',
};

const componentName = 'CONTAINER_DETAILS_PAGE';

interface ContainerDetailsProps extends ReduxProps, StylesProps<ReturnType<typeof styles>> {
  history;
  match;
  eximType: string;
  isExports: boolean;
  reloadPage: () => void;
  isHBL: () => boolean;
  errorMessage: string;
  details;
  tracking;
  trackingDetails;
  containerDetails;
  shipmentLoading: boolean;
  statusWiseCount: StatusWiseCount;
  newShipmentView: boolean;
  isContainerTab?: boolean;
  tabId: string;
  handleArchiveShipment: (items: CardData[]) => void;
  handleUnArchiveShipment: () => void;
  mainPageTabId: string;
  handleRefresh: (item: CardData) => void;
  toggleMapZoom: (value?: boolean, mapProps?: any) => void;
  isVesselRouteMapZoomed: boolean;
}

interface FetchShipmentDetailsProps {
  id: string;
  shipmentType: string;
}

interface StatusWiseCount {
  AT_ORIGIN: number;
  IN_TRANSIT: number;
  TRANSSHIPMENT: number;
  REACHED_DESTINATION_PORT: number;
  TRACKED_COUNT: number;
  TRACKING_PENDING_COUNT: number;
  TOTAL: number;
}

interface ReduxProps {
  fetchShipmentDetails: (body: FetchShipmentDetailsProps, nonPublic: boolean) => any;
  stopPolling: () => Promise<void>;
  startPoller: (fetchShipmentDetailsProps) => Promise<void>;
  resetShipmentData: () => Promise<void>;
  isTableLoading: boolean;
  status: string | null;
  errorStatus: number;
  userData: UserData;
  container;
  permissions: CTPermissions;
  shipmentBlContainer: string;
}

interface StateProps {
  pageNumber: number;
  isEditModalVisible: boolean;
  showAddManualTrackingModal: boolean;
  showBLContainerDetailModal?: boolean;
  editContainerItem;
  selectedSubContainer?: CardData;
  statusFilter: string;
  addProduct?: boolean;
  editing?: boolean;
  reload?: boolean;
  view: string;
  eventTypeView: string;
  showMoreData: boolean;
}

declare let google: any;

const ContainerDetails = (props: ContainerDetailsProps) => {

  const {
    fetchShipmentDetails,
    stopPolling,
    startPoller,
    shipmentLoading,
    statusWiseCount,
    errorMessage,
    errorStatus,
    permissions,
    history,
    match,
    eximType,
    tracking,
    trackingDetails,
    classes,
    theme,
    reloadPage,
    isHBL,
    userData,
    container,
    shipmentBlContainer,
    containerDetails,
    details,
    newShipmentView,
    isContainerTab,
    tabId,
    handleArchiveShipment,
    handleUnArchiveShipment,
    mainPageTabId,
    handleRefresh,
    toggleMapZoom,
    isVesselRouteMapZoomed,
  } = props;

  const [state, setStateUtil] = useState<StateProps>({
    pageNumber: 1,
    statusFilter: 'ALL',
    showAddManualTrackingModal: false,
    isEditModalVisible: false,
    editContainerItem: undefined,
    selectedSubContainer: isValidArray(containerDetails) ? containerDetails[0] : {
      ...details,
      tracking,
    } || {},
    view: container?.isVesselTrackingPresent ? viewToggle.MAP : viewToggle.LIST,
    eventTypeView: EVENT_TYPE.ALL,
    showMoreData: false,
  });

  const {
    pageNumber,
    showAddManualTrackingModal,
    isEditModalVisible,
    showBLContainerDetailModal,
    editContainerItem,
    selectedSubContainer,
    statusFilter,
    addProduct,
    editing,
    reload,
    view,
    eventTypeView,
    showMoreData,
  } = state;

  const {
    unique_id,
  } = match?.params || {};

  const shipmentType = match?.params?.shipmentType?.toUpperCase();

  const {
    blReceived,
    isComplete,
    isArchived,
    isBkContainer,
    isBlContainer,
  } = container || {};

  let { id } = match.params || {};
  useEffect(() => {
    JavascriptTimeAgo.locale(en);
    let nonPublic = true;
    if (isPublicLink()) {
      id = unique_id;
      nonPublic = false;
      initIntercom();
    }
    loadData(id, nonPublic);
    return () => {
      stopPolling();
      resetShipmentData();
    };
  }, [reload]);

  useEffect(() => {
    setState({
      selectedSubContainer: isValidArray(containerDetails) ? containerDetails[0] : {
        ...details,
        tracking,
      } || {},
    });
  }, [containerDetails]);

  function isPublicLink() {
    return !!unique_id;
  }

  function loadData(id, nonPublic) {
    startPoller({ shipmentType, shipmentId: id });
  }

  const renderLabel = (text) => {
    return <div className={classes.labelStyle}>{text}</div>;
  };

  const renderVal = (text) => {
    return <div className={classes.valStyle}>{text}</div>;
  };

  const renderLabelVal = (label, val) => {
    if (label === 'CO2e Emissions*'){
      return <Col span={8}>
      <Row>
        <Tooltip title='Estimated Emissions (TTW)'><Col
          className={classes.alignStyle}
          span={8}>
          {renderLabel(label)}
        </Col></Tooltip>
        <Tooltip title={val} placement = 'topLeft' ><Col
          className={classes.alignStyle}
          span={16}>{renderVal(val || '-')}
        </Col></Tooltip>
      </Row>
    </Col>;
    } else if (label ==='ETA (POD)'){
      return <Col span={8}>
        <Row>
          <Col
            className={classes.alignStyle}
            span={8}>
            {renderLabel(label)}
          </Col>
          <Col
            className={classes.alignStyle}
            span={16} style={{display: 'inline'}}>
              <Col>{renderVal(val[0] || '-')}</Col>
              {renderContainerEtaHistory(val[1])}
          </Col>
        </Row>
      </Col>;
    } else {
      return <Col span={8}>
        <Row>
          <Col
            className={classes.alignStyle}
            span={8}>
            {renderLabel(label)}
          </Col>
          <Col
            className={classes.alignStyle}
            span={16}>{renderVal(val || '-')}
          </Col>
        </Row>
      </Col>;
    }
  };
  
  const renderCol = (span, data) => {
    return <Col span={span}>{data}</Col>;
  };
  function isAddContainerVisible() {
    if (shipmentBlContainer === SHIPMENT_TYPE.CN && !newShipmentView) return false;
    return true;
  }

  function isContainerView() {
    if (
      shipmentBlContainer === SHIPMENT_TYPE.CN &&
      !newShipmentView
    ) return true;
    return [SHIPMENT_TYPE.CN, 'cn_detail'].indexOf(shipmentType) > -1;
  }

  function isCardArchived() {
    return container && container?.isArchived;
  }

  function handleSubContainerClick(selectedSubContainer) {
    setState({
      selectedSubContainer,
    });
  }

  function setCurrentPage(page) {
    window.scrollTo(0, 0);
    setState({
      pageNumber: page,
    });
  }

  function getMonitoringModules() {
    const shipperModules = window.localStorage.getItem('monitoringModules');
    return shipperModules ? JSON.parse(shipperModules) : null;
  }

  function initIntercom() {
    const monitoringModules = getMonitoringModules();
    const isIntercomDisabled = monitoringModules && monitoringModules.disable_intercom;
    if (isIntercomDisabled) {
      return;
    }
    window.intercomSettings = {
      app_id: 'ntvhrj4m',
      name: '',
    };
    intercom();
  }

  function setState(newState: Partial<StateProps>) {
    setStateUtil((oldState: StateProps) => {
      return {
        ...oldState,
        ...newState,
      };
    });
  }

  function goToContainer() {
    if (history?.location?.state?.from === 'shipmentExecutionContainers') {
      history.goBack();
    }
    history.push(getContainerTrackingRoute(eximType,
      history?.location?.state?.from && map[history.location.state.from] ?
        map[history.location.state.from] : 'shipment'), { doNotReset: true });
  }

  function filterByStatus(statusFilter) {
    setState({ statusFilter });
  }

  function getFilteredContainers() {
    if (trackingDetails?.trackingType === SHIPMENT_TYPE?.HBL) {
      return [{ ...trackingDetails }];
    }
    if (!(containerDetails?.length)) {
      return [];
    }
    if (!statusFilter || statusFilter === 'ALL') {
      return [...containerDetails];
    }
    if (statusFilter === 'DELAYED') {
      return containerDetails.filter((container: any) => (
         container?.tag === 'DELAYED'));
    }
    return containerDetails.filter((container: any) => (
       container?.status === statusFilter));
  }

  function handleRemoveFilters() {
    filterByStatus(null);
  }

  function reportIssue() {
    const intercom = window.Intercom;
    if (intercom) {
      intercom('showNewMessage', `Hi Shipsy team, I am facing issues with the tracking shown for BL number ${container?.blNumber}.`);
    }
  }

  function handleReloadClick() {
    const check = true;
    loadData(id, check);
  }

  function getBLContainerModalProps() {
    let blContainerModalProps: any = {
      ...{
        ...container,
        teamSelected: container?.teamId || details?.teamId || trackingDetails?.teamId,
        originPort: container?.originPortCode,
        destinationPort: container?.destinationPortCode,
      },
      trackingRequestId: match.params.id,
      containerDetails,
      show: showBLContainerDetailModal,
      shipmentShippingLine: {
        id: trackingDetails?.shippingLineId || container?.shippingLineId,
        name: trackingDetails?.shippingLineName || container?.shippingLineName,
      },
      movementType: container?.movementType,
    };
    if (editContainerItem) {
      blContainerModalProps = {
        ...blContainerModalProps,
        isEdit: true,
        container: {
          id: editContainerItem.id,
          containerNumber: editContainerItem.containerNumber,
          containerType: editContainerItem.containerType,
          containerSize: editContainerItem.containerSize,
        },
      };
    } else if (showBLContainerDetailModal) {
      blContainerModalProps = {
        ...blContainerModalProps,
        isEdit: false,
        trackingRequestId: match.params.id || container?.id || container?.shipmentId,
        accessorId: trackingDetails.accessorId || container?.accessorId,
        accessorType: trackingDetails.accessorType || container?.accessorType,
        
      };
    }
    return blContainerModalProps;
  }

  const renderEditModal = () => {
    return <React.Fragment>
      {isEditModalVisible ? <QuickAddContainerTracking
        typeAdd={container?.trackingType === SHIPMENT_TYPE.HBL ? SHIPMENT_TYPE.HBL : isContainerView() ? SHIPMENT_TYPE.CONTAINER : SHIPMENT_TYPE.BL}
        editData={container}
        isVisible={isEditModalVisible}
        backRoute={location.pathname}
        onClose={({isSuccess}) => {
          setState({ isEditModalVisible: false });
          isSuccess ? handleReloadClick() : null;
        }}
      /> : null}
    </React.Fragment>;
  };

  function getShipmentNumberKey() {
    switch (shipmentType?.toUpperCase()) {
      case SHIPMENT_TYPE.BL: return 'blNumber';
      case SHIPMENT_TYPE.CN: return 'containerNumber';
      case SHIPMENT_TYPE.BK:
      default: return 'bookingNumber';
    }
  }

  const renderAddManualTrackingModal = () => {
    if (!showAddManualTrackingModal) return null;
    return <AddManualTrackingEventModal
      visible={showAddManualTrackingModal}
      shipmentId={match?.params?.containerId || match?.params?.id}
      shipmentType={shipmentType?.toUpperCase()}
      shipmentNumber={container[getShipmentNumberKey()]}
      shipmentShippingLine={{
        id: container?.shippingLineId,
        name: container?.shippingLineName,
      }}
      onClose={(isSuccess = false) => {
        if (isSuccess) {
          reloadPage();
          handleReloadClick();
        }
        setState({
          showAddManualTrackingModal: false,
        });
      }}
    />;
  };

  const renderBlContainerDetailModal = () => {
    const blContainerModalPropsToSend = getBLContainerModalProps();
    if (!showBLContainerDetailModal || !blContainerModalPropsToSend) return null;
    return <BLContainerDetailModal
      {...blContainerModalPropsToSend}
      onClose={(isSuccess = false) => {
        setState({
          showBLContainerDetailModal: false,
          editContainerItem: undefined,
        });
        if (isSuccess) {
          handleReloadClick();
          reloadPage();
        }
      }}
    />;
  };

  const renderProductSideDrawer = () => {
    if (!addProduct) return null;
    const { products, productDetails } = container;
    return <ProductSideDrawer
      onlyProduct={true}
      showTracking={false}
      shipmentNumber={getShipmentNumber(container)}
      products={products || productDetails}
      handleClose={() => handleProduct(false)}
    />;
  };

  const renderModals = () => {
    return <div>
      {renderProductSideDrawer()}
      {renderEditModal()}
      {renderAddManualTrackingModal()}
      {renderBlContainerDetailModal()}
    </div>;
  };

  const renderEditText = (text, fallback) => {
    if (!permissions.write || isPublicLink()) return fallback;
    return <span
      onClick={(e) => {
        e.preventDefault();
        e.stopPropagation();
        if (isCardArchived()) return;
        handleEdit();
      }}
      className={classes.anchorForEdit}>
      {text}
    </span>;
  };

  function isManuallyTracked() {
    return !!container?.isManuallyTracked;
  }

  function handleEdit(addTracking = false) {
    setState({
      [addTracking ? 'showAddManualTrackingModal' : 'isEditModalVisible']: true,
    });
  }

  function handleAddContainer() {
    setState({
      showBLContainerDetailModal: true,
    });
  }

  function handleEditContainer(item) {
    setState({
      editContainerItem: item,
      showBLContainerDetailModal: true,
    });
  }

  const handleDeleteContainer = (item) => {
    Modal.confirm({
      okText: 'Confirm',
      title: 'Confirm Deletion',
      content: 'Are your sure you want to delete this container? This can’t be undone.',
      onOk: async () => {
        const response = await disableContainerByContainerNumber({ id: [item.id] });
        if (!response.isSuccess) {
          message.error(response.errorMessage);
        } else {
          message.success(`Container ${item.id} Deleted successfully.`);
          handleReloadClick();
        }
      },
    });
  };

  const getContainerNumber = () => {
    return selectedSubContainer?.containerNumber?.split('(')[0] || '';
  };

  const renderContainer = () => {
    if (
      container?.trackingType === SHIPMENT_TYPE.HBL ||
      isContainerView() ||
      !selectedSubContainer ||
      selectedSubContainer.doNotShowTracking
    ) return null;
    return <div
      className={classes.containerNumber}>
      Container # {getContainerNumber()}
    </div>;
  };

  const renderTrackingView = (container, state) => {
    return <div
      style={transitionStyles[state]}
      className={classes.stepCard}
      data-intercom-target={`${componentName}_timeline`}>
      {isHBL() && renderEventTypeToggle()}   
      {renderContainer()}
      <div
        style={{
          overflowY: 'auto',
          height: 'auto',
        }} >
        {(!isHBL()) &&
         <UnifiedTrackingTimeline
          currentEventIndex={container?.currentEventIndex || container?.currentEventIndex === 0 ?
          container?.currentEventIndex : trackingDetails?.currentEventIndex}
          tracking={container?.tracking || trackingDetails?.tracking}
          doNotShowTracking={container?.doNotShowTracking}
          containerNumber={getContainerNumber()}
        /> }
        {(isHBL()) && renderTrackingBasedOnEventType(container,state)}
      </div>
      <div className={classes.reportAnchor}>
        <a onClick={reportIssue}>
          Report an Issue</a>
      </div>
    </div>;
  };

  const renderTrackingBasedOnEventType = (container,state)=> {
    let currentEventIndex = container?.currentEventIndex || container?.currentEventIndex === 0 ? 
    container?.currentEventIndex : trackingDetails?.currentEventIndex
    let tracking= container?.tracking || trackingDetails?.tracking
    let doNotShowTracking= container?.doNotShowTracking
    let containerNumber= getContainerNumber()

    if (eventTypeView === EVENT_TYPE.SHIPMENT){
      let currentIndex = currentEventIndex
      const filteredTracking: any = [];
      tracking.forEach((element, i)=> {
        if (element.isNonShipmentEvent === false){
          filteredTracking.push(element)
        }
        else {
          if (currentIndex > 0){
            currentIndex = currentIndex - 1      
          }
        }
      })  
      return <UnifiedTrackingTimeline
        currentEventIndex={currentIndex}
        tracking={filteredTracking}
        doNotShowTracking={doNotShowTracking}
        containerNumber={containerNumber}/>
    } else if (eventTypeView === EVENT_TYPE.NON_SHIPMENT){
      let currentIndex = currentEventIndex
      const filteredTracking: any = [];
      tracking.forEach((element)=> {
        if (element.isNonShipmentEvent === true){
          filteredTracking.push(element)
        }
        else {
          if (currentIndex > 0){
            currentIndex = currentIndex - 1      
          }
        }
      })
      return <UnifiedTrackingTimeline
        currentEventIndex={currentIndex}
        tracking={filteredTracking}
        doNotShowTracking={doNotShowTracking}
        containerNumber={containerNumber}/>
    } else {
      return <UnifiedTrackingTimeline
      currentEventIndex={currentEventIndex}
      tracking={tracking}
      doNotShowTracking={doNotShowTracking}
      containerNumber={containerNumber}/>
    }
    
  };
  const renderSupplierFields = () => {
    return container?.movementType !== MOVEMENT_TYPES.EXPORT && <>
      {container?.supplierName && <div className={classes.summaryCol}>
        <span className={classes.label}>Supplier: </span>
        <span>{container?.supplierName}</span>
      </div>}
      {container?.supplierReferenceNumber && <div className={classes.summaryCol}>
        <div className={classes.label}>Supplier Reference <br /><div>Number:</div> </div>
        <div>{container?.supplierReferenceNumber}</div>
      </div>}</>;
  };

  const paginationCount = 10;
  const noDataFound = () => {
    return <div className={classes.notFound}>
      <div className={classes.notFoundItems}>
        <LightHouseIcon className={classes.blackIcon} width="184" height="184">
        </LightHouseIcon></div>
      <div className={classes.notFoundItems}
        style={{ fontWeight: 600, fontSize: 16 }}>
        No containers to show</div>
      <div className={classes.notFoundItems}
        style={{ paddingTop: 10, fontSize: 14 }}>
        {(!shipmentLoading && shipmentType?.toUpperCase() !== SHIPMENT_TYPE.CN && isManuallyTracked())
          ? 'Add containers to fetch details'
          : 'To get more results, try adjusting your filters.'}</div>
    </div>;
  };

  const noTrackingFound = () => {
    return <div
      className={classes.notFound}
      style={{ marginLeft: 15 }}>
      <div className={classes.notFoundItems}>
        <LightHouseIcon className={classes.blackIcon}
          width="184" height="184"></LightHouseIcon></div>
      <div className={classes.notFoundItems}
        style={{ fontWeight: 600, fontSize: 14 }}>
        No tracking information to show</div>
      {!isHBL() && <div className={classes.notFoundItems}
        style={{ paddingTop: 10, fontSize: 12 }}>
        To get more results, try selecting another container.</div>}
    </div>;
  };

  if (errorMessage) {
    return (<div style={{ height: '100%' }}>
      {(errorStatus && errorStatus === 404) ?
          <NotFound404 title="Container Tracking" />
          : <Alert message={errorMessage} type="error" />
      }
    </div>);
  }

  const getNumber = (reference: string, tag: string): React.ReactElement => {
    return <div className={classes.flexRow}>
      <span className={classes.containerLabel}>{tag}</span>
      <span className={classes.containerTitle}>
        {(reference?.split('(')[0] || '')}
      </span>
    </div>;
  };

  const renderContainerNumber = () => {
    const arr: React.ReactElement[] = [];
    if (container?.containerNumber) arr.push(getNumber(container?.containerNumber, 'Container#'));
    if (container?.blNumber) arr.push(getNumber(container?.blNumber, 'BL#'));
    if (container?.bookingNumber) arr.push(getNumber(container?.bookingNumber, 'Booking#'));
    return <span className={classes.flexRow}>
      {arr.map((item, index) => <React.Fragment>
        {item}
        {(index !== arr.length - 1) && renderDevider()}
      </React.Fragment>)}
    </span>;
  };

  const renderDevider = () => {
    return <span
      style = {{
        height: 16,
        width: 1,
        marginLeft: '8px',
        borderLeft: `2px solid ${tokens.colors.textSecondary}`,
        color: tokens.colors.textSecondary,
      }}
    />;
  };

  const renderContainerTag = () => {
    const delayed = (statusWiseCount as any)?.DELAYED;
    const delayedCount = container?.tag === 'DELAYED' && delayed ? ` : ${delayed}` : '';
    return <React.Fragment>
      {container?.tag ?
        (<Tag className={(container?.tag && (container?.tag === 'DELAYED'))
          ? classNames(classes.error, classes.cursorStyle) :
          classNames(classes.success, classes.cursorStyle)}
          style={{
            borderColor: colorStatusMapping[container?.tag],
            background: colorStatusMapping[container?.tag],
          }}
        >
          {`${STATUS_LABELS[container?.tag]}${delayedCount}`}
        </Tag>) : ''}
    </React.Fragment>;
  };

  const renderBackToListView = () => {
    return <React.Fragment>
      {(history.location?.state &&
        ['containerTrackingShipment', 'containerTrackingBL',
          'containerTrackingContainer', 'shipmentExecutionContainers',
        ].indexOf(history.location.state.from) > -1) ?
        (<div>
          <Button
            icon={'left'}
            onClick={goToContainer}
            className={classes.transparentButton}>Back To List View</Button>
        </div>) : ''}
    </React.Fragment>;
  };

  const renderContainerHeader = () => {
    return <div className={classes.navbarParent}>
      <div style={{ display: 'flex', alignItems: 'center' }}>
        {renderContainerNumber()}
        {renderContainerTag()}
      </div>
      {renderBackToListView()}
    </div>;
  };

  const renderShipLinedIcon = () => {
    return <div className={classes.summaryIcon}>
      <ShipOutlinedIcon width="7em" height="7em"></ShipOutlinedIcon>
    </div>;
  };

  const renderShippingLineName = () => {
    return <div className={classes.summaryCol}>
      <div className={classes.label}>
        Shipping Line:
        </div>
      <div className={classes.values}>
        {container?.shippingLineName}
      </div>
    </div>;
  };

  const renderPOL = () => {
    return <div className={classes.summaryCol}>
      <span className={classes.label}>POL:</span>
      <span style={{ wordBreak: 'break-word' }}>
        {container?.loadingPortName ? container?.loadingPortName : (
          isManuallyTracked() ? renderEditText('Add POL', '-') : '-'
        )}
      </span>
    </div>;
  };

  const renderPOD = () => {
    return <div className={classes.summaryCol}>
      <span className={classes.label}>POD:</span>
      <span style={{ wordBreak: 'break-word' }}>
        {container?.dischargePortName ? container?.dischargePortName : (
          isManuallyTracked() ? renderEditText('Add POD', '-') : '-'
        )}
      </span>
    </div>;
  };

  const renderOrigin = () => {
    return <div className={classes.summaryCol}>
      <span className={classes.label}>Origin:</span>
      <span style={{ wordBreak: 'break-word' }}>
        {container?.originPortName ? container?.originPortName : (
          isManuallyTracked() ? renderEditText('Add Origin', '-') : '-'
        )}
      </span>
    </div>;
  };

  const renderDestination = () => {
    return <div className={classes.summaryCol}>
      <span className={classes.label}>Destination:</span>
      <span style={{ wordBreak: 'break-word' }}>
        {container?.destinationPortName ? container?.destinationPortName : (
          isManuallyTracked() ? renderEditText('Add Destination', '-') : '-'
        )}
      </span>
    </div>;
  };

  const renderETAPOD = () => {
    return <div className={classes.summaryCol}>
      <span className={classes.label}>ETA (POD):</span>
      <span style={{ wordBreak: 'break-word' }}>
        {container?.etaPodFinal ? moment(container?.etaPodFinal).format('DD MMM YYYY') : (
          isManuallyTracked() ? renderEditText('Add ETA', '-') : '-'
        )}
      </span>
    </div>;
  };

  const renderETADestination = () => {
    return <div className={classes.summaryCol}>
      <span className={classes.label}>{container?.reachedDestinationAt ? 'Date of Arrival: ' : 'ETA (Destination): '}</span>
      <span style={{ wordBreak: 'break-word' }}>
        {container?.finalEta ? moment(container?.finalEta).format('DD MMM YYYY') : (
          isManuallyTracked() ? renderEditText('Add ETA', '-') : '-'
        )}
      </span>
    </div>;
  };

  const renderDemurrageFreeDays = () => {
    return <div className={classes.summaryCol}>
      <div className={classes.label}>
        Demurrage Free Days: </div>
      <div>
        {container?.demurrageFreeDays || '-'}
      </div>
    </div>;
  };

  const renderFreeDaysAndInternalNumber = () => {
    return <div className={classes.summaryRow}>
      <div className={classes.summaryCol}>
        <div className={classes.label}>
          Detention Free Days: </div>
        <div>
          {container?.detentionFreeDays || '-'}
        </div>
      </div>
      <div className={classes.summaryCol}>
        <div className={classes.label}>
          CFS Free Days: </div>
        <div>
          {container?.cfsFreeDays || '-'}
        </div>
      </div>
      <div className={classes.summaryCol}>
        <div className={classes.label}>
          Internal Number:</div>
        <div>
          {container?.internalReferenceNumber || '-'}
        </div>
      </div>
      {renderCustomerName()}
    </div>;
  };

  const renderCustomerName = () => {
    const customerName = (userData.type === 'FF' ?
      container?.shipperName : container?.customerName) || '-';
    if (
      container?.movementType === MOVEMENT_TYPES.IMPORT &&
      userData.type !== 'FF'
    ) return null;
    return <div className={classes.summaryCol}>
      <div className={classes.label}>
        {userData.type === 'FF' ? 'Shipper:' : 'Customer:'}
      </div>
      <Tooltip
        title={customerName}
        className={classes.wrappedText}>
        {customerName}
      </Tooltip>
    </div>;
  };

  const renderPromiseTransitDays = () => {
    if (!container?.promisedEta && !container?.promisedTransitDays) return null;
    return <div className={classes.summaryRow}>
      {container?.promisedTransitDays &&
        <div className={classes.summaryCol}>
          <span className={classes.label}>Promised Transit Days: </span>
          <span>{container?.promisedTransitDays}</span>
        </div>}
      {container?.promisedEta &&
        <div className={classes.summaryCol}>
          <span className={classes.label}>
            Promised ETA:
          </span>
        <span>{moment(container?.promisedEta).format('DD MMM YY')}</span>
      </div>}
    </div>;
  };

  const totalContainers = () => {
    return <React.Fragment>
      {!isContainerView() ?
        <div className={classes.summaryCol}>
          <span className={classes.label}>Total Containers: </span>
          <span>{container?.noOfContainers ? container?.noOfContainers : '-'}</span>
        </div>
        : (
          container?.blNumber ? <div className={classes.summaryCol}>
            <div className={classes.label}>BL Number:</div>
            <div>{container?.blNumber || '-'}</div>
          </div> : null
        )}
    </React.Fragment>;
  };

  const renderOtherDetails = () => {
    return <React.Fragment>
      <div className={classes.summaryCol}>
        <span className={classes.label}>Invoice Number: </span>
        <span>{container?.invoiceNumberList?.length ?
          container?.invoiceNumberList?.join(', ') : '-'}</span>
      </div>
      <div className={classes.summaryCol}>
        <span className={classes.label}>Contract Number: </span>
        <span>{container?.contractNumber ?
          container?.contractNumber : '-'}</span>
      </div>
      <div className={classes.summaryCol}>
        <span className={classes.label}>BL Issue Date: </span>
        <span>{container?.blIssueDate ?
          moment(container?.blIssueDate).format('DD MMM YY') : '-'}</span>
      </div>
    </React.Fragment>;
  };

  const renderCommonDetails = (details: [any]) => {
    return details.map((val, index) => {
      return <Row key={index} className={classes.detailsRow}>
        {Object.keys(val).map(key => {
          return <Col key={key} className={classes.detailsCol}>
                  {typeof(val[key]) === 'string' ? 
                    <Tooltip
                      title={val[key] || ''}
                    >
                    <Row style={{color: tokens.colors.textSecondary, fontWeight: tokens.fontWeight.semibold, overflow: 'hidden',whiteSpace: 'nowrap', textOverflow: 'ellipsis', maxWidth: '12ch'}}>{val[key] || '-'}</Row>
                    </Tooltip>
                   :
                   <Row style={{color: tokens.colors.textSecondary, fontWeight: tokens.fontWeight.semibold}}>{val[key] || '-'}</Row>
                  }
                  {key === 'CO2e Emissions*' ? <Tooltip placement='bottom' title='Estimated Emissions (TTW)'><Row style={{color: tokens.colors.textSecondary, fontWeight: tokens.fontWeight.regular, marginTop: '9px'}}>{key}</Row></Tooltip> : <Row style={{color: tokens.colors.textSecondary, fontWeight: tokens.fontWeight.regular, marginTop: '9px'}}>{key}</Row>}
                  
                </Col>
        })}
      </Row>
    })
  };

  interface containerSummaryRow {
    type: string;
    portName?: string;
    portCode?: string;
    eta?: string;
    actualArrivalTime?: string;
    etaPodFinalHistory?: string[];
  }

  const firstLetterCapitalFormatting = (str: string | undefined) => {
    return str ? ((str.split(' ').map((word) => word.charAt(0).toUpperCase() + word.slice(1).toLowerCase())).join(' ')) : undefined;
  }

  const renderContainerSummaryHeading = () => {
    return <Row style={{color: tokens.colors.textSecondary, fontSize: tokens.fontSize.small, fontWeight: tokens.fontWeight.semibold, textAlign: 'center'}}>
      <Col span={6}>{''}</Col>
      <Col span={6}>{'Port Name & Code'}</Col>
      <Col span={6}>{'ETA'}</Col>
      <Col span={6}>{'Actual Arrival Time'}</Col>
    </Row>
  }

  const renderContainerSummaryRow = ({type, portName, portCode, eta, actualArrivalTime, etaPodFinalHistory}: containerSummaryRow) => {
    return <Row style={{color: tokens.colors.textSecondary, fontSize: tokens.fontSize.small, fontWeight: tokens.fontWeight.regular, textAlign: 'center'}}>
      <Col span={6} style={{textAlign: 'left', fontWeight: 500}}>{type}</Col>
      <Col span={6}>{(portName || portCode) ?`${portName ? firstLetterCapitalFormatting(portName) : ''} (${portCode || ''})` : '-'}</Col>
      <Col span={6}>
        <Col>{eta || '-'} </Col>
        {renderContainerEtaHistory(etaPodFinalHistory)}
      </Col>
      <Col span={6}>{actualArrivalTime || '-'}</Col>
    </Row>
  };

  const renderContainerEtaHistory= (etaPodFinalHistory) => {
    if (isValidArray(etaPodFinalHistory)){
      return  <Col>
        <Dropdown trigger={['hover']} placement='bottomCenter'
          overlay={renderEtaHistoryDropdown(etaPodFinalHistory)}
          overlayStyle={{width: 'max-content', fontSize: '9px', color: tokens.colors.textSecondary}} >
            <u style={{fontSize: '10px', color: '#3876EE'}}>{'View Historic ETA(s)'}</u>
        </Dropdown>
      </Col>
    } else {
      return;
    }
  };

  const renderEtaHistoryDropdown = (etaPodFinalHistory:string[]) => { 
    let etaHistory = clone(etaPodFinalHistory);
    etaHistory = etaHistory.reverse().slice(0,5);
    return (
        <div style={{backgroundColor: tokens.colors.bgWhite, color: tokens.colors.textTertiary, padding: '0 10px'}}>
          <Menu style={{width: 'max-content'}}>
            <Menu.Item className={classes.etaMenu} style={{textAlign: 'center', backgroundColor: tokens.colors.bgSubtle}}>
              <div style={{color: tokens.colors.text}}>{'Historic ETAs (latest five)'}</div>
            </Menu.Item>
            {etaHistory.map((element: string) => {
            return (
              <Menu.Item className={classes.etaMenu} disabled={true}>
                  {'\u2022 '}{element}
              </Menu.Item>
                );
            })}
          </Menu>
          <div style={{height: '2px', backgroundColor: '#3876EE'}}></div>
        </div>
      );
  };

  const renderContainerSummaryDescription = (data: any) => {
    return <div style={{width: 'max-content', fontSize: '9px', color: tokens.colors.textSecondary, padding: '10px', backgroundColor: '#E9FFEE', fontStyle: 'italic'}}>
      {Object.keys(data)?.map((key) => {
        return <Row key={key} style={{display: 'flex'}}>
          <Col style={{color: tokens.colors.textTertiary}}>{`${key} : `}</Col>
          <Col style={{fontWeight: 800, marginLeft: '4px'}}>{data[key] || '-'}</Col>
        </Row>
      })}
    </div>
  };

  const renderContainerSummary = (selectedContainer) => {
    return <Steps direction="vertical" size="small" className={classes.steps}>
       <Steps.Step 
        title={renderContainerSummaryHeading()} 
        icon={<div className={classes.progressDot} style={{ backgroundColor: tokens.colors.bgWhite, borderColor: tokens.colors.bgWhite }}/>} />
      <Steps.Step 
        title={renderContainerSummaryRow({
          type: 'POL',
          portName: selectedContainer?.loadingPortName,
          portCode: selectedContainer?.loadingPortCode,
          actualArrivalTime: selectedContainer?.polArrivalTime ? moment(selectedContainer?.polArrivalTime).format('DD MMM YYYY') : '-'
        })} 
        description={renderContainerSummaryDescription({
          'Origin': firstLetterCapitalFormatting(selectedContainer?.orginPortName),
          'Estimated Sailing Date': selectedContainer?.estimatedSailingDate ? moment(selectedContainer?.estimatedSailingDate).format('DD MMM YYYY') : '-',
          'Actual Sailing Date': selectedContainer?.actualSailingDate ? moment(selectedContainer?.actualSailingDate).format('DD MMM YYYY') : '-',
        })} 
        icon={<div className={classes.progressDot} />} />
      {selectedContainer?.transshipmentDetails?.map((transshipment) => {
        return <Steps.Step 
          title={renderContainerSummaryRow({
            type: 'Transshipment',
            portName: transshipment?.transshipmentName,
            portCode: transshipment?.transshipmentCode,
            eta: transshipment?.transshipmentEta ? moment(transshipment?.transshipmentEta).format('DD MMM YYYY') : '-',
            actualArrivalTime: transshipment?.actualArrival ? moment(transshipment?.actualArrival).format('DD MMM YYYY') : '-'
          })} 
          icon={
              <div
                className={classes.progressDot}
                style={{ borderColor: '#00D518', backgroundColor: tokens.colors.bgWhite}}/>
              }
          />
      })}
      <Steps.Step 
        title={renderContainerSummaryRow({
          type: 'POD',
          portName: selectedContainer?.dischargePortName,
          portCode: selectedContainer?.dischargePortCode,
          eta: selectedContainer?.etaPodFinal ? moment(selectedContainer?.etaPodFinal).format('DD MMM YYYY') : '-',
          actualArrivalTime: selectedContainer?.actualArrivalPod ? moment(selectedContainer?.actualArrivalPod).format('DD MMM YYYY') : '-',
          etaPodFinalHistory: selectedContainer?.etaPodFinalHistory?.map((etaHistory) => ( moment(etaHistory.eta).format('DD MMM YYYY')))
        })} 
        description={renderContainerSummaryDescription({
          'Destination': firstLetterCapitalFormatting(selectedContainer?.destinationPortName),
          'Destination ETA': selectedContainer?.finalEta ? moment(selectedContainer?.finalEta).format('DD MMM YYYY') : '-',
        })} 
        icon={<div className={classes.progressDot} />} />
    </Steps>
  };

  const renderShipmentDetails = () => {
    return <div className={classes.row}>
      <Collapse>
      <Collapse.Panel key="1" header={<div className={classes.detailsHead}>Shipment Details</div>}>
        {renderContainerSummary(selectedSubContainer)}
        <Row className={classes.titleRow}>Other Details</Row>
        {renderCommonDetails(
          [{
            'Total Containers': container?.noOfContainers,
            'Demurrage Free Days': container?.demurrageFreeDays,
            'Detention Free Days': container?.detentionFreeDays,
            'CFS Free Days': container?.cfsFreeDays,
            ...(userData.type === 'FF') && {'Shipper': userData.type === 'FF' ? container?.shipperName : container?.ffId ? container?.ffName : container?.customerName},
            ...(userData.type !== 'FF' && container?.ffId) && {'FF': userData.type === 'FF' ? container?.shipperName : container?.ffId ? container?.ffName : container?.customerName},
            ...(userData.type !== 'FF' && !container?.ffId) && {'Customer': userData.type === 'FF' ? container?.shipperName : container?.ffId ? container?.ffName : container?.customerName},
            ...(userData.type !== 'FF' && !container?.ffId) && {'Supplier': container?.supplierName},
            'Product': renderProducts(),
            'CO2e Emissions*': container.co2Emissions ? `${container?.co2Emissions} Kg` : '-',
          }]
        )}
      </Collapse.Panel>
      </Collapse>
    </div>
  };

  const renderSummaryDetails = () => {
    return <div className={classes.row}>
      <Collapse>
      <Collapse.Panel key="1" header={<div className={classes.detailsHead}>Shipment Details</div>}>
      <Row className={classes.rowStyle}>
        {renderLabelVal('POL', container?.loadingPortName)}
        {renderLabelVal('ETA(Destination)', container?.finalEta ? moment(container?.finalEta).format('DD MMM YYYY') : '')}
        {renderLabelVal(
          userData.type === 'FF' ? 'Shipper' : container?.ffId ? 'FF' : 'Customer',
          userData.type === 'FF' ? container?.shipperName : container?.ffId ? container?.ffName : container?.customerName)}
      </Row>
      <Row className={classes.rowStyle}>
        {renderLabelVal('POD', container?.dischargePortName )}
        {renderLabelVal('Total Containers', container?.noOfContainers)}
        {userData.type !== 'FF' && !container?.ffId && renderLabelVal('Supplier', container?.supplierName)}
      </Row>
      <Row className={classes.rowStyle}>
        {renderLabelVal('Origin', container?.originPortName)}
        {renderLabelVal('Demurrage Free Days', container?.demurrageFreeDays)}
        {renderLabelVal('Product', renderProducts())}
      </Row>
      <Row className={classes.rowStyle}>
        {renderLabelVal('Destination', container?.destinationPortName )}
        {renderLabelVal('Detention Free Days', container?.detentionFreeDays)}
        {renderLabelVal('Actual Sailing Date', container?.actualSailingDate ? moment(container?.actualSailingDate).format('DD MMM YYYY') : '-')}
      </Row>
      <Row className={classes.rowStyle}>
        {renderLabelVal('ETA (POD)', container?.etaPodFinal ? moment(container?.etaPodFinal).format('DD MMM YYYY') : '')}
        {renderLabelVal('CFS Free Days', container?.cfsFreeDays)}
        {renderLabelVal('Estimated Sailing Date', container?.estimatedSailingDate ? moment(container?.estimatedSailingDate).format('DD MMM YYYY') : '-')}
      </Row>
      </Collapse.Panel>
      </Collapse>
    </div>;
  };

  const renderSummaryDetailsForHBL = () => {
    return <div className={classes.row}>
      <Row className={classes.rowStyle}>
        <Col span={12}
          className={classes.detailsHead}
        >Shipment Details
      </Col>
      </Row>
      <Row className={classes.rowStyle}>
        {renderLabelVal('POL', container?.loadingPortName)}
        {renderLabelVal('ETA(Destination)', container?.finalEta ? moment(container?.finalEta).format('DD MMM YYYY') : '')}
        {renderLabelVal(
          userData.type === 'FF' ? 'Shipper' : container?.ffId ? 'FF' : 'Customer',
          userData.type === 'FF' ? container?.shipperName : container?.ffId ? container?.ffName : container?.customerName)}
      </Row>
      <Row className={classes.rowStyle}>
        {renderLabelVal('POD', container?.dischargePortName )}
        {renderLabelVal('Demurrage Free Days', container?.demurrageFreeDays)}
        {userData.type !== 'FF' && !container?.ffId && renderLabelVal('Supplier', container?.supplierName)}
      </Row>
      <Row className={classes.rowStyle}>
        {renderLabelVal('Origin', container?.originPortName)}
        {renderLabelVal('Detention Free Days', container?.detentionFreeDays)}
        {renderLabelVal('Product', renderProducts())}
      </Row>
      <Row className={classes.rowStyle}>
        {renderLabelVal('Destination', container?.destinationPortName )}
        {renderLabelVal('CFS Free Days', container?.cfsFreeDays)}
        {renderLabelVal('ETA (POD)', [container?.etaPodFinal ? moment(container?.etaPodFinal).format('DD MMM YYYY') : '', container?.etaPodFinalHistory?.map((etaHistory) => ( moment(etaHistory.eta).format('DD MMM YYYY')))])}
        </Row>
      <Row className={classes.rowStyle}>
        {renderLabelVal('CO2e Emissions*', container?.co2Emissions )}
      </Row>
    </div>;
  };

  function handleProduct(addProduct) {
    setState({ addProduct });
  }

  const renderProducts = () => {
    const count = details?.products?.length - 1 || 0; 
    const name = details?.products ? details?.products[0]?.internalName : undefined;
    return <div
      className={classes.valStyle}
      onClick={() => handleProduct(true)}
      style={{display: 'flex'}}
    >
      <Tooltip
        title={name}
      >
      <span style={{
        maxWidth: '8ch',
        overflow: 'hidden',
        whiteSpace: 'nowrap',
        textOverflow: 'ellipsis',
        display: 'block',
        marginRight: '4px',
      }}>{name} </span></Tooltip> {count > 0 &&
      <span style={{
        color: tokens.colors.primary,
        cursor: 'pointer',
      }}>+{count} more</span>}  {(!name && !count) ? '-' : ''}
    </div>;
  };

  const renderProduct = () => {
    const { products } = container;
    return <div className={classes.summaryCol}>
      {isValidArray(products) && <Tooltip
        className={classes.flexColumn}
        title={products[0].internalName}>
        {products[0].internalName} {products.length > 1 &&
        <span className={classes.addBooking}
          style={{
            marginRight: 5,
            cursor: 'pointer',
            marginLeft: 5,
          }}
          onClick={e => handleProduct(true)}
        >
          <Icon type="plus" />
          {products.length - 1} More</span>}
      </Tooltip>}
    </div>;
  };

  const renderTooltip = () => {
    const {
      lastBlReceivedAction,
    } = container;
    if (!lastBlReceivedAction) return null;
    return <React.Fragment>
        {isValidBoolean(blReceived) && <span
          style={{
            marginRight: 8,
          }}>
          {blReceived ? 'Yes' : 'No'}
        </span>}
      <Tooltip
        title={lastBlReceivedAction}>
        <Icon
          type="info-circle"
          theme="filled"
        />
        {container?.selfShipment && permissions.write && <span style={{
          margin: '0px 5px',
          border: '1px solid #666666',
        }}/>}
      </Tooltip>
    </React.Fragment>;
  };

  async function handleEditShipment(body) {
    if (shipmentType === SHIPMENT_TYPE.CN) return editContainer(body);
    return editBL(body);
  }

  async function handleMarkReceived() {
    const body = {
      ...container,
      customFields: undefined,
      sharedByType: container?.sharedByType,
      shippingLine: container?.shippingLineId,
      accessType: container?.accessorType,
      blReceived: !Boolean(blReceived),
    }
    setState({ editing: true });
    const response = await handleEditShipment(body);
    setState({
      editing: false,
      reload: response.isSuccess ? !Boolean(reload) : reload,
    });
  }

  const renderMarkContent = () => {
    if (isPublicLink()) return null;
    if (editing) return <Spin size="small"/>;
    return <React.Fragment>
      {renderTooltip()}
      {container?.selfShipment && permissions.write && <a
        onClick={handleMarkReceived}
        className={classes.transparentButton}>
        {blReceived ? 'Mark Not Received' : 'Mark Recieved'}
      </a>}
    </React.Fragment>;
  };

  function isMarkingAllowed(): boolean {
    return (
      isPublicLink() ||
      isComplete ||
      isArchived ||
      isBkContainer ||
      isBlContainer
    );
  }

  const renderMarking = () => {
    if (isMarkingAllowed()) return null;
    return <div className={classes.summaryCol}>
      <div className={classes.label}>BL Received:</div>
      {renderMarkContent()}
    </div>;
  };

  const renderAddTracking = () => {
    const shippingLineId = trackingDetails?.shippingLineId || container?.shippingLineId;
    if (!shippingLineId) return null;
    return <React.Fragment>
      {(
        !isPublicLink() &&
        isManuallyTracked() &&
        !isAddContainerVisible() &&
        !isCardArchived()) &&
        (!isContainerTab || !container?.blNumber) &&
        <div className={classes.addContainerStyle}
        style={{
          marginBottom: 8,
        }}>
          <Button
            disabled={Boolean(!container?.blNumber && !container?.containerNumber && !container?.bookingNumber)}
            type="primary"
            onClick={() => handleEdit(true)}>
            Add Tracking
          </Button>
        </div>}
    </React.Fragment>;
  };

  const renderStatusCount = () => {
    if (!statusWiseCount) return null;
    const allStatusCount = statusWiseCount?.TOTAL || 0;
    return <div className={classes.containerCol}>
      <Button
        style={(!statusFilter) ? {
          color: tokens.colors.primary,
          borderBottom: `2px solid ${tokens.colors.primary}`,
          fontWeight: tokens.fontWeight.semibold,
        } : {}}
        className={classes.filterButton}
        onClick={(e) => {
          filterByStatus(null);
        }}
      >All ({allStatusCount})</Button>
    </div>;
  };

  const renderStatusLabel = () => {
    if (!statusWiseCount) return null;
    return <React.Fragment>
      {Object.keys(STATUS_KEYS).map((statusVal: any) => (
        <div className={classes.containerCol} key={statusVal}>
          <Button
            style={(statusFilter &&
              statusFilter === statusVal) ? {
                color: tokens.colors.primary,
                borderBottom: `2px solid ${tokens.colors.primary}`,
                fontWeight: tokens.fontWeight.semibold,
              } : {}}
            className={classes.filterButton}
            onClick={() => {
              filterByStatus(statusVal);
            }}
          >
            {`${STATUS_LABELS[statusVal]} (${statusWiseCount[statusVal] || 0})`}
          </Button>
        </div>
      ))}
    </React.Fragment>;
  };

  const renderAddContainer = () => {
    const shippingLineId = trackingDetails?.shippingLineId || container?.shippingLineId;
    if (!shippingLineId) return null;
    return <React.Fragment>
      {(
        !isPublicLink() &&
        isManuallyTracked() &&
        isAddContainerVisible() &&
        !isCardArchived()) &&
         <div className={classes.addContainerStyle}>
          <Button
            type="default"
            style={{
              marginRight: 12,
            }}
            onClick={handleAddContainer}>
            Add Container
          </Button>
          {(!isContainerTab || !container?.blNumber) &&
          <Button
            disabled={Boolean(!container?.blNumber && !container?.containerNumber && !container?.bookingNumber)}
            type="primary"
            onClick={() => handleEdit(true)}>
            Add Tracking
          </Button>}
        </div>}
    </React.Fragment>;
  };

  const renderContainerStatus = () => {
    return <div
      style={{
        paddingRight: '16px',
        paddingBottom: 0,
      }}
      className={classes.containerRow}  
      data-intercom-target={`${componentName}_metrics_filter`}>
      {statusWiseCount ? renderStatusCount() : <div style={{ width: '32%' }}></div>}
      {statusWiseCount ? renderStatusLabel() : <div style={{ width: '32%' }}></div>}
      {renderAddContainer()}
      {renderAddTracking()}
      {container?.isVesselTrackingPresent && <div className={classes.toggleDiv}>
        {renderMapViewToggle()}
      </div>}
    </div>;
  };

  const renderBorder = (item: Container, index: number) => {
    const filteredContainers = getFilteredContainers();
    const lastItem = index > 0 ?
      filteredContainers[10 * (pageNumber - 1) + index - 1] : {
        doNotShowTracking: true,
      };
    if (!item.doNotShowTracking || lastItem.doNotShowTracking) return null;
    return <div
      className={classes.devider}
      style = {{
        borderTop: index && '1px solid #979797',
      }}
    >
      <Tooltip title="">
        <Icon
          type="info-circle"
          theme="filled"
          style={{ marginRight: 8 }}
        />
      </Tooltip>
      These containers are not part of the BL and not being tracked
    </div>;
  };

  const renderSubContainer = (item: Container, index: number) => {
    return <React.Fragment>
      {renderBorder(item, index)}
      <SubContainerCard
        isContainerView={isContainerView()}
        isPublicLink={isPublicLink()}
        bookingNumber = {container?.bookingNumber}
        handleEdit={handleEdit}
        handleArchiveShipment={handleArchiveShipment}
        handleUnArchiveShipment={handleUnArchiveShipment}
        handleDelete={handleDeleteContainer}
        style={{
          border: selectedSubContainer?.id === item.id ?
          `1px solid ${theme.primaryColor || '#065492'}` : 'unset',
        }}
        item={item}
        index={index}
        blNumber={container?.blNumber ? container?.blNumber : null}
        isHBL={isHBL}
        permissions={permissions}
        container = {container}
        onClick={() => (handleSubContainerClick(item))}
        mainPageTabId={mainPageTabId}
      />
    </React.Fragment>;
  };

  function getDataSource(filteredContainers: Container[]) {
    return filteredContainers
    .slice(
      (pageNumber - 1) * paginationCount,
      Math.min((pageNumber) * paginationCount, filteredContainers.length),
    );
  }

  const renderContainerList = () => {
    const filteredContainers = getFilteredContainers();
    if (isValidArray(filteredContainers)) {
      return <List
        dataSource={getDataSource(filteredContainers)}
        renderItem={renderSubContainer}
      />;
    }
    return <div
      className={classes.placeholder}>
      {noDataFound()}
    </div>;
  };

  const renderPagination = () => {
    const filteredContainers = getFilteredContainers();
    return <React.Fragment>
      {(filteredContainers.length <= paginationCount) ? '' :
        (<div className={classes.footer}>
          <Pagination
            onChange={setCurrentPage}
            total={filteredContainers.length}
            size="small"
            defaultCurrent={1}
            defaultPageSize={paginationCount} />
        </div>)}
    </React.Fragment>;
  };
  const renderMapViewToggle = () => {
    return <Radio.Group
    value={view}
    onChange={e => {
      setState({ view: e.target.value });
    }}
    style={{ display: 'flex', alignItems: 'center' }}
    >
      <Radio.Button style={{ padding: '0px 8px' }} value={viewToggle.LIST}>
        <span className={classes.viewToggleStyle}>
        <Icon type="unordered-list" /> List View
        </span>
      </Radio.Button>
      <Radio.Button style={{ padding: '0px 8px' }} value={viewToggle.MAP}>
        <span className={classes.viewToggleStyle}>
        <LocationPinIcon color={view === viewToggle.MAP ? '#40A9FF' : null}/> Map View
        </span>
      </Radio.Button>
    </Radio.Group>
  }
  const renderEventTypeToggle = () => {
    return <Radio.Group
    value={eventTypeView}
    onChange={e => {
      setState({ eventTypeView: e.target.value });
    }}
    style={{ display: 'flex', alignItems: 'center', padding: '15px 0px 0px 18px' }}
    >
      <Radio.Button style={{ padding: '0px 8px' }} value={EVENT_TYPE.ALL}>
        <span className={classes.eventTypeToggleStyle}>
        All
        </span>
      </Radio.Button>
      <Radio.Button style={{ padding: '0px 8px' }} value={EVENT_TYPE.SHIPMENT}>
        <span className={classes.eventTypeToggleStyle}>
         Shipment
        </span>
      </Radio.Button>
      <Radio.Button style={{ padding: '0px 8px' }} value={EVENT_TYPE.NON_SHIPMENT}>
        <span className={classes.eventTypeToggleStyle}>
         Non-Shipment
        </span>
      </Radio.Button>
    </Radio.Group>
  }

  const renderTrackingAndMap = () => {
    const vesselLocation = { lat: container?.latitude, lng: container.longitude };
    const mapRoute = container?.mapRoute;
    const status = container?.status;
    const center = { lat: container?.latitude, lng: container.longitude };

    const timelines = {
      [container.originPortCode]: {
        ...(container.originPortCode === container.loadingPortCode && {
          atd: container?.actualSailingDate,
          etd: container?.estimatedSailingDate,
        }),
      },
      [container.loadingPortCode]: {
        atd: container?.actualSailingDate,
        etd: container?.estimatedSailingDate,
      },
      [container.dischargePortCode]: {
        ata: container?.actualArrivalPod,
        eta: container?.etaPodFinal,
      },
      [container.destinationPortCode]: {
        ...(container.dischargePortCode === container.destinationPortCode ? {
          ata: container?.actualArrivalPod,
          eta: container?.etaPodFinal,
        } : 
        { ata: container?.reachedDestinationAt }),
      }
    };

    const transshipmentDetails = isContainerView() ? container?.transshipmentDetails :
      container?.containerDetails?.find(container => container.containerNumber === container?.containerNumber)?.transshipmentDetails;

    (transshipmentDetails)?.forEach((item) => {
      timelines[item.transshipmentCode] = {
        atd: item?.transshipmentDepartureAt,
        eta: item?.transshipmentEta,
      }
    })

    return <div style={{ width: 466 }}>
      {view === viewToggle.MAP && <MapVesselRoute
      status={status}
        mapRoute={mapRoute}
        googleMapURL={GOOGLE_PLACES_API_URL}
        loadingElement={<div style={{ marginTop: 8, height: 577, width: 466 }} />}
        containerElement={<div style={{ marginTop: 8, height: 577, width: 466 }} />}
        mapElement={<div style={{ marginTop: 8, height: 577, width: 466 }} />}
        zoom={3}
        center={center}
        markerPosition={vesselLocation} 
        timelines={timelines}
        toggleMapZoom={(value) => toggleMapZoom(value, {
          mapRoute,
          status,
          center,
          vesselLocation,
          timelines,
          getFilteredContainers,
          selectedSubContainer,
          container,
          classes,
          noTrackingFound,
          shipmentType,
          renderTrackingView,
          duration,
          isHBL,
          containerDetails,
        })}
        isZoomed={isVesselRouteMapZoomed}
      />}
      {view === viewToggle.LIST && <ContainerDetailsTrackingList
        getFilteredContainers={getFilteredContainers}
        selectedSubContainer={selectedSubContainer}
        container={container}
        classes={classes}
        noTrackingFound={noTrackingFound}
        shipmentType={shipmentType}
        renderTrackingView={renderTrackingView}
        duration={duration}
        isHBL={isHBL}
        containerDetails={containerDetails}
      />}
    </div>
  }

  const renderContainerListAndPagination = () => {
    return <Row
      gutter={8}
      className={classes.trackingBox}
      style={{ marginTop: '1px' }}>
      {renderCol(16, <React.Fragment>
        {renderContainerList()}
        {renderPagination()}
        </React.Fragment>)}
      {renderCol(8, renderTrackingAndMap())}
    </Row>;
  };

  return (
    <div style={{
      minWidth: MIN_WIDTH,
      paddingLeft: 10,
    }}>
      {isHBL() ? renderSummaryDetailsForHBL() : renderShipmentDetails()}
      {!isHBL() && renderContainerStatus()}
      {renderContainerListAndPagination()}
      {renderModals()}
    </div>
  );
};

const mapStateToProps = ({ masterData }, ownProps) => ({
  userData: masterData.userData,
  permissions: containerTrackingPermissions(masterData),
});

const mapDispatchToProps = dispatch => (bindActionCreators({
  startPoller,
  stopPolling,
  resetShipmentData,
}, dispatch));

const ContainerDetailsStyled = injectSheet(styles)(ContainerDetails);
const ContainerRouted = withRouter(ContainerDetailsStyled);
export default memo(connect(mapStateToProps, mapDispatchToProps)(ContainerRouted));
